export const getReactRoot = () => {
    const reactRoot = document.querySelector('#react-root') || document.body;
    if (!reactRoot) throw new Error('Unable to find "#react-root"');
    if (reactRoot.shadowRoot) return reactRoot.shadowRoot as unknown as Element;

    return reactRoot;
};

export const getReactRootDocument = ():
    | Document
    | null
    | ShadowRoot
    | undefined =>
    document.activeElement?.shadowRoot ||
    document.querySelector('#react-root')?.shadowRoot ||
    document;
